// src/features/lockers/hooks/useLockerPermissions.ts
import { usePermissions } from 'react-admin';
import { Locker } from '../types';

export const useLockerPermissions = (record?: Locker) => {
  const { permissions: role } = usePermissions<'SuperAdmin' | 'GroupAdmin' | 'HotelAdmin' | 'Receptionist' | string>();

  const canManage = role && ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canCreate = canManage;
  const canEdit = canManage;
  const canDelete = role === 'SuperAdmin'; // Solo SuperAdmin puede eliminar
  const canBlock = canManage; // Admins pueden bloquear

  return { canManage, canCreate, canEdit, canDelete, canBlock };
};